export const BUSINESS = {
  name: "Ascencio Auto Repair",
  tagline: "Where Good Work Speaks for Itself",
  street: "217 S Alliance Ct",
  city: "Oklahoma City, OK 73128",
  email: "ascencio12autorepair@gmail.com",
  phone: "(405) 510-6511",
  phoneHref: "tel:+14055106511",
  hoursDays: "Monday–Friday",
  hoursTime: "8:00 AM–6:00 PM",
  mapsListing:
    "https://www.google.com/maps/search/?api=1&query=Ascencio+Auto+Repair+217+S+Alliance+Ct+Oklahoma+City+OK+73128",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=217+S+Alliance+Ct,+Oklahoma+City,+OK+73128",
  mapEmbed:
    "https://www.google.com/maps?q=217+S+Alliance+Ct,+Oklahoma+City,+OK+73128&output=embed",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/4116170/pexels-photo-4116170.jpeg?auto=compress&cs=tinysrgb&w=1920",
  diesel:
    "https://images.pexels.com/photos/8985518/pexels-photo-8985518.jpeg?auto=compress&cs=tinysrgb&w=1260&h=850&fit=crop",
  diagnostics:
    "https://images.pexels.com/photos/4116172/pexels-photo-4116172.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  repair:
    "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMHJlcGFpcmluZyUyMHRydWNrJTIwZGFya3xlbnwwfHx8fDE3ODcyNzk2NTl8MA&ixlib=rb-4.1.0&q=85",
  steel:
    "https://images.unsplash.com/photo-1552656967-7a0991a13906?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjYXIlMjBlbmdpbmUlMjBwYXJ0cyUyMHN0ZWVsfGVufDB8fHx8MTc4NzI3OTY1OXww&ixlib=rb-4.1.0&q=85",
};
